import { faChevronLeft, faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormEvent, useEffect, useState } from 'react';
import { Button, Card, Container, Form, Modal } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { Footer } from '../../components/Footer/Footer';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import { Topbar } from '../../components/Topbar/Topbar';
import { useCapacitor } from '../../../hooks/useCapacitor';
import { useTranslation } from 'react-i18next';
import { Title } from '../../components/Title/Title';

const TestComponent = () => {
  const { getTest, courses, validateTest } = useFirebase();
  const { courseId, id } = useParams<any>();
  const history = useHistory();
  const [test, setTest] = useState<any>(null);
  const [answers, setAnswers] = useState<{ [key: string]: any }>({});
  const [isValidating, setIsValidating] = useState(false);
  const [showValidationDialog, setShowValidationDialog] = useState(false);
  const [testSuccess, setTestSuccess] = useState<boolean>(null);
  const { isNative } = useCapacitor();
  const { t } = useTranslation();

  useEffect(() => {
    if (!courseId || !id) history.goBack();
  }, []);

  useEffect(() => {
    (async () => {
      if (!id) return;
      const test = await getTest(courseId, id);
      if (!test) return;
      setTest(test);
    })();
  }, [id, courses]);

  const onTestSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const obj = { [courseId]: { [id]: answers } };
    setIsValidating(true);
    const { status } = await validateTest(obj);
    setIsValidating(false);
    setTestSuccess(status);
    setShowValidationDialog(true);
  };

  if (!test) return <FullscreenLoader />;

  return (
    <>
      <Title>{test.name}</Title>

      <div style={{ marginBottom: '72px' }}>
        <div style={{ backgroundColor: '#141414', position: 'fixed', top: '0', left: '0', right: '0', zIndex: 100 }}>
          <Topbar />
        </div>
      </div>

      <Container className={'my-5'}>
        <h3 className={'d-flex flex-column flex-md-row align-items-start align-items-md-center mb-3 justify-content-between'}>
          <span>{test.name}</span>
          <Button variant={'dark'} className={'mt-3 mt-md-0'} onClick={() => history.push('..')}>
            <FontAwesomeIcon icon={faChevronLeft} size={'xs'} className={'mr-2'} />
            <span>{t('test.labels.tornaAlCorso')}</span>
          </Button>
        </h3>

        <Form onSubmit={onTestSubmit}>
          {test.questions.map((question) => (
            <Card key={question.id} bg={'dark'} className={'mb-3'}>
              <Card.Body>
                <Card.Title>{question.value}</Card.Title>
                {question.answers.map((answer) => (
                  <Form.Check
                    required
                    disabled={isValidating}
                    key={answer.id}
                    name={question.id}
                    type={'radio'}
                    label={answer.value}
                    id={answer.id}
                    value={answer.id}
                    onChange={(e) => {
                      const { value } = e.target;
                      setAnswers((previous) => ({ ...previous, [question.id]: value }));
                    }}
                  />
                ))}
              </Card.Body>
            </Card>
          ))}

          <div className={'d-flex justify-content-end'}>
            <Button variant={'primary'} type={'submit'} style={{ width: '150px' }} disabled={isValidating}>
              {isValidating ? <FontAwesomeIcon icon={faCircleNotch} spin /> : t('labels.invia')}
            </Button>
          </div>
        </Form>
      </Container>

      <Footer />

      <Modal centered={isNative} show={showValidationDialog} onHide={() => history.push('..')}>
        <Modal.Header>
          <Modal.Title>{testSuccess ? t('test.labels.testSuperato') : t('test.labels.testNonSuperato')}</Modal.Title>
        </Modal.Header>
        {/*<Modal.Body>
          Hai terminato i minuti a disposizione per la versione di prova. Per continuare ad usufruire dei contenuti di {process.env.REACT_APP_TITLE} è
          necessario un abbonamento.
        </Modal.Body>*/}
        <Modal.Footer>
          <Button variant={'primary'} onClick={() => history.push('..')}>
            {t('test.labels.tornaAlCorso')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TestComponent;
